import { initializeApp } from '@firebase/app';
import { getRemoteConfig, fetchAndActivate, getAll } from '@firebase/remote-config';
import { Capacitor } from '@capacitor/core';
import { useEffect, useState } from 'react';
import { defaultRemoteConfig } from './defaultRemoteConfig';
export const useFirebaseRemoteConfig = (firebaseConfig, defaultConfig) => {
    const [remoteConfig, setRemoteConfig] = useState();
    const [state, setState] = useState({
        isLoading: true
    });
    const [error, setError] = useState();
    useEffect(() => {
        if (!firebaseConfig)
            return;
        setError(undefined);
        const config = Object.assign(Object.assign({}, firebaseConfig), { appId: firebaseConfig.appId[Capacitor.getPlatform()] });
        const app = initializeApp(config);
        const remoteConfig = getRemoteConfig(app);
        remoteConfig.settings.minimumFetchIntervalMillis = 0;
        remoteConfig.defaultConfig = Object.assign(Object.assign({}, defaultRemoteConfig), (defaultConfig || {}));
        setRemoteConfig(remoteConfig);
        // Default values
        setState({ isLoading: true, values: getAll(remoteConfig) });
        // Remote values
        fetchAndActivate(remoteConfig)
            .then(() => {
            setState({ isLoading: false, values: getAll(remoteConfig) });
        })
            .catch(error => {
            console.error('Failed to fetch Firebase Remote Config', error);
            setError(error);
            setState(values => values && Object.assign(Object.assign({}, values), { isLoading: false }));
        });
    }, [firebaseConfig]);
    return { remoteConfig, values: state.values, isLoading: state.isLoading, error };
};
//# sourceMappingURL=useFirebaseRemoteConfig.js.map